import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>About Born in YU | Celebrating Yugoslav Heritage</title>
        <meta name="description" content="Learn about Born in YU, a brand celebrating Yugoslav heritage through brutalist design and bureaucratic chic apparel. Discover our mission and story." />
        <link rel="canonical" href="https://borninyu.com/about" />
      </Helmet>
      <main className="min-h-screen bg-white">
      <section className="p-6 md:p-24">
        <div className="max-w-4xl mx-auto">
          <div className="border-[3px] border-black p-8 md:p-16 relative mb-12">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-white px-4 border-[3px] border-black font-black uppercase tracking-widest text-sm">
              {t('about.classification')}
            </div>

            <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-8">
              {t('footer.links.about')}
            </h1>

            <div className="font-typewriter text-sm md:text-base leading-relaxed uppercase text-gray-800 space-y-6">
              <p>{t('about.paragraph1')}</p>

              <p>{t('about.paragraph2')}</p>

              <p>{t('about.paragraph3')}</p>

              <p>{t('about.paragraph4')}</p>

              <p className="border-l-4 border-[#C41E3A] pl-4 italic">
                &ldquo;{t('about.quote')}&rdquo;
              </p>

              <p>{t('about.paragraph5')}</p>
            </div>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="border-2 border-black p-6">
                <div className="text-5xl font-black text-[#C41E3A] mb-2">1943</div>
                <div className="text-xs uppercase font-bold">{t('about.stat1Label')}</div>
              </div>
              <div className="border-2 border-black p-6">
                <div className="text-5xl font-black text-[#C41E3A] mb-2">6</div>
                <div className="text-xs uppercase font-bold">{t('about.stat2Label')}</div>
              </div>
              <div className="border-2 border-black p-6">
                <div className="text-5xl font-black text-[#C41E3A] mb-2">∞</div>
                <div className="text-xs uppercase font-bold">{t('about.stat3Label')}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default About;
